<fieldset class="border rounded-3 p-3" [formGroup]="formGroup">
  <legend class="subtitle-4 float-none w-auto px-3">Type of Metal Loss</legend>
  <div class="container">
    <div class="form-group row align-items-center">
      <div class="col-sm-6 align-self-center">
        <input
          type="radio"
          id="ltap_metalLossType_LTA"
          name="ltap_metalLossType"
          value="LTA"
          [checked]="selectedMetalLossType === 'LTA'"
          (change)="onMetalLossTypeChange('LTA')"
        />
        <label for="ltap_metalLossType_LTA">&nbsp;Local Thin Area (LTA)</label>
      </div>
      <div class="col-sm-6">
        <input
          type="radio"
          id="ltap_metalLossType_Groove"
          name="ltap_metalLossType"
          value="Groove"
          [checked]="selectedMetalLossType === 'Groove'"
          (change)="onMetalLossTypeChange('Groove')"
        />
        <label for="ltap_metalLossType_Groove">&nbsp;Groove</label>
      </div>
    </div>
  </div>
</fieldset>
